module.exports = __webpack_public_path__ + "img/ball_6.763555e9.svg";